export class CompositeArticleImportModel {
    counter: number = 0;
    code: number = 0;
    alterCode: string = "";
    alterCode2: string = "";
    name: string = "";
    observation: string = "";
    familyCode: string = "";
    groupCode: string = "";
    subgroupCode: string = "";
    active: boolean = false;
    articleCode: number = 0;
    quantity: number = 0;

    constructor(
        counter: number = 0,
        code: number = 0,
        alterCode: string = "",
        alterCode2: string = "",
        name: string = "",
        observation: string = "",
        familyCode: string = "",
        groupCode: string = "",
        subgroupCode: string = "",
        active: boolean = false,
        articleCode: number = 0,
        quantity: number = 0
    ) {
        this.counter = counter;
        this.code = code;
        this.alterCode = alterCode;
        this.alterCode2 = alterCode2;
        this.name = name;
        this.observation = observation;
        this.familyCode = familyCode;
        this.groupCode = groupCode;
        this.subgroupCode = subgroupCode;
        this.active = active;
        this.articleCode = articleCode;
        this.quantity = quantity;
    }
}